import { useState, useRef, useEffect } from "react";

interface ShareMenuProps {
  title: string;
  variant?: "solid" | "outline";
}

const options = [
  { icon: "ri-link", label: "复制链接", key: "copy" },
  { icon: "ri-weibo-fill", label: "分享到微博", key: "weibo" },
  { icon: "ri-wechat-fill", label: "分享到微信", key: "wechat" },
  { icon: "ri-qq-fill", label: "分享到 QQ", key: "qq" },
];

export default function ShareMenu({ title, variant = "outline" }: ShareMenuProps) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleClick = async (key: string) => {
    if (key === "copy") {
      try {
        await navigator.clipboard.writeText(window.location.href);
      } catch {
        // 忽略剪贴板权限错误
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } else {
      setOpen(false);
    }
  };

  const btnClass =
    variant === "solid"
      ? "bg-primary-500 text-background-50 hover:bg-primary-600"
      : "border border-background-300 text-foreground-800 hover:bg-background-100";

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`inline-flex items-center gap-1.5 h-10 px-4 rounded-md text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${btnClass}`}
      >
        <i className="ri-share-forward-line"></i>
        分享
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-48 rounded-lg bg-background-50 border border-background-200 shadow-lg z-30 p-2 animate-fade-up">
          <p className="px-2 py-1.5 text-xs text-foreground-500 truncate">分享《{title}》</p>
          {options.map((opt) => (
            <button
              key={opt.key}
              type="button"
              onClick={() => handleClick(opt.key)}
              className="w-full flex items-center gap-2 px-2 py-2 rounded-md text-sm text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer text-left"
            >
              <i className={`${opt.icon} text-base text-primary-500`}></i>
              {opt.label}
            </button>
          ))}
          {copied && (
            <p className="px-2 pt-1.5 text-xs text-secondary-600 flex items-center gap-1">
              <i className="ri-check-line"></i>
              链接已复制
            </p>
          )}
        </div>
      )}
    </div>
  );
}